interface IProps {
    creditCard: string;
    emptyCreditCard: string;
    unauthorizedCreditCard: string;
    incorrectCreditCard: string;
    clientIdFromPartner: string | undefined;
}

interface IReturn {
    message: string;
    status: 'Error' | '';
}


const validateCreditCard = ({ creditCard, emptyCreditCard, unauthorizedCreditCard, incorrectCreditCard, clientIdFromPartner }: IProps): IReturn => {
    let value = creditCard;
    value = value.replace(/\D/g, '');

    value = value.replace(/^(\d{4})(\d{4})(\d{4})(\d{4})/, '$1 $2 $3 $4');

    if (value.length === 0) {
        return {
            message: emptyCreditCard,
            status: 'Error',
        };
    } /* else if (value.length > 6 && value.length < 15) {
        return {
            message: incorrectCreditCard,
            status: 'Error',
        }; */
    // }


    // const value = creditCard.replace(/[^\w]/g, '');

    // if (value === '00000000000' || !value)
    //   return {
    //     message: emptyCreditCard,
    //     status: 'Error',
    //   };
    return {
        message: '',
        status: '',
    };
};

export { validateCreditCard };
